/**
 * LoadingSpinner Component
 * Consistent loading indicator
 */
import type { ReactElement } from 'react';

type SpinnerSize = 'sm' | 'md' | 'lg';

interface LoadingSpinnerProps {
  size?: SpinnerSize;
  message?: string;
}

export default function LoadingSpinner({
  size = 'md',
  message = 'Loading...',
}: LoadingSpinnerProps): ReactElement {
  const sizeClasses: Record<SpinnerSize, string> = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-8">
      <div
        className={`${sizeClasses[size]} border-2 border-theme-primary border-t-transparent rounded-full animate-spin`}
      />
      {message && <p className="text-theme-text-secondary text-sm">{message}</p>}
    </div>
  );
}
